/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';

// Servicios.
import SeguridadService from '../services/seguridadService';

// Components
import Heading from '../components/heading/Heading';
import CustomNoRowsOlverlay from '../components/custom/CustomNoRowsOlverlay';
import Item from '../components/custom/Item';
import msgNotificacion from "../scripts/notification";
import Formatter from '../scripts/formatters';
import { 
  Grid, 
  Checkbox,
  Stack,
  Tooltip,
  IconButton,
  Button
} from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';
import msgAlerta from '../scripts/alert';

// Modals.
import ModalPermisos from '../components/modal/Permisos';
import ModalUsuarios from '../components/modal/Usuario';

// Iconos.
import EditIcon from '@mui/icons-material/Edit';
import BlockIcon from '@mui/icons-material/Block';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';

// Redux.
import { useDispatch } from 'react-redux';
import { showProgress } from '../redux/reducers/progress.Slice';
import { PAGE_SIZE, NAME_PROJECT } from '../redux/constants/index';

export default function Usuarios () {
  const dispatch = useDispatch()
  const [selectionModel, setSelectionModel] = useState()
  const [usuario, setUsuario] = useState({ Id: -1, Nombre: '' })
  const [loading, setLoading] = useState(false)
  const [dataUsuarios, setDataUsuarios] = useState([])
  const [dataRoles, setDataRoles] = useState([])
  const [openModalPermisos, setOpenModalPermisos] = useState(false)
  const [dataUsuarioSelected, setDataUsuarioSelected] = useState(null)
  const [editUser, setEditUser] = useState(false)
  const [openModalUsuarios, setOpenModalUsuarios] = useState(false)
  const [noChanges, setNoChanges] = useState(true)

  function RenderCheckBox(props) {
    const [checked, setChecked] = useState(props.value) // Valor vinculado de reacción iniciada con parámetro de "filas"
  
    // Controlador de clics del usuario para establecer la casilla de verificación o desactivarla
    const handleChange = (event) => {
      setChecked(event.target.checked);
    }

    return (
      <Checkbox
        label="some text"
        size='medium'
        checked={checked} 
        onChange={handleChange} 
        disabled
      />
    );
  }
  
  const columns = [
    { 
      field: 'IdUsuario',
      headerName: 'Id',
      width: 20,
      align: 'center',
      headerAlign: 'center',      
    },
    { 
      field: 'Nombre',
      headerName: 'Usuario',
      width: 100,
      align: 'center',
      headerAlign: 'center',      
    },
    { 
      field: 'IdEmpleado',
      headerName: 'Cod Empleado',
      width: 120,
      align: 'center',
      headerAlign: 'center',
    },
    { 
      field: 'NombreCompleto',
      headerName: 'Nombre del Empleado',
      minWidth: 250,
      flex: 1,
    },
    { 
      field: 'Cargo',
      headerName: 'Cargo',
      minWidth: 250,
      flex: 1,
    },
    { 
      field: 'Rol',
      headerName: 'Rol',
      width: 100,
      align: 'center',
      headerAlign: 'center',
    },
    { 
      field: 'IsBloqueado',
      headerName: 'Bloqueado',
      width: 90,
      align: 'center',
      headerAlign: 'center',
      renderCell: RenderCheckBox
    },
    {
      field: 'UltimaSesion',
      headerName: 'Ultima sesión',
      minWidth: 150,
      align: 'center',
      headerAlign: 'center',      
      valueFormatter: ( value ) => Formatter.dateTimeFormatter(value)
    },
    {
      field: 'Acciones',
      headerName: 'Acciones',
      width: 120,
      headerAlign: 'center',      
      renderCell: (params) => {
        const editarUsuario = (e) => {
          const data = params.row
          
          setEditUser(true)
          setDataUsuarioSelected(data)
          setOpenModalUsuarios(true)
        }

        const bajaUsuarioAlert = () => {
          try {
            msgAlerta('Dar de baja usuario', `¿Estás seguro que lo desea darle de baja al usuario <strong>${params.row.Nombre}<strong>?`, 'question', darDeBajaUsuario)
          } catch (error) {
            console.error(error)
          }
        }

        const darDeBajaUsuario = () => {
          try {
            const dataObject = params.row;

            const data = {
              codUsuario: dataObject.IdUsuario,
              codRol: -1
            }
                        
            SeguridadService.bajaUsuario(data)
              .then((response) => {
                if (!response) {
                  msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')
                  return
                }
  
                if (response.Codigo === 1) {
                  msgNotificacion(response.Mensaje, 'success')
                  getUsuarios(data)
                } else {
                  msgAlerta('Error de validación', response.Mensaje, 'warning')
                }
              })
              .catch((error) => {
                console.log('Error:', error.message)
              })
          } catch (error) {
            console.error(error)
          }
        }

        const reestablecerContrasenaAlert = () => {
          try {
            msgAlerta('Reestablecer contraseña', `¿Estás seguro que lo desea reestablecer la contraseña del usuario <strong>${params.row.Nombre}<strong>?`, 'question', reestablecerContrasena)
          } catch (error) {
            console.error(error)
          }
        }

        const reestablecerContrasena = () => {
          try {
            const dataObject = params.row;

            const data = {
              codUsuario: dataObject.IdUsuario,
              codRol: -1
            }
                        
            SeguridadService.reestablecerContrasena(data)
              .then((response) => {
                if (!response) {
                  msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')
                  return
                }
  
                if (response.Codigo === 1) {
                  msgNotificacion(response.Mensaje, 'success')
                  getUsuarios(data)
                } else {
                  msgAlerta('Error de validación', response.Mensaje, 'warning')
                }
              })
              .catch((error) => {
                console.log('Error:', error.message)
              })
          } catch (error) {
            console.error(error)
          }
        }
        
        return (
          <Stack direction='row' justifyContent='center'>
            <Tooltip title='Editar Usuario'>
              <IconButton aria-label='buscar' color='info' onClick={editarUsuario}>
                <EditIcon fontSize='medium'/>
              </IconButton>
            </Tooltip>
            <Tooltip title='Dar de baja'>
              <IconButton aria-label='buscar' color='error' onClick={bajaUsuarioAlert}>
                <BlockIcon fontSize='medium' />
              </IconButton>
            </Tooltip>
            <Tooltip title='Reestablecer contraseña'>
              <IconButton aria-label='buscar' color='warning' onClick={reestablecerContrasenaAlert}>
                <SettingsBackupRestoreIcon fontSize='medium' />
              </IconButton>
            </Tooltip>
          </Stack>
        );
      }
    },
  ]

  const getUsuarios = async (data) => {
    try {      
      setLoading(true)

      SeguridadService.getUsuarios(data)
      .then((response) => {
          if (!response) {
            msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')
            setLoading(false)
            return
          }
  
          setTimeout(() => {
            if (response.Codigo === 1) {
              setDataUsuarios(response.Data)
            } else {
              setDataUsuarios([])
              msgNotificacion(response.Mensaje, 'info')
            }
            setLoading(false)
          }, 500);
      })
      .catch((error) => {
        dispatch(showProgress(false));
        msgNotificacion(error, 'error')
      })
    } catch (error) {
      console.error(error)
    }
  }

  const addUsers = () => {
    try {      
      setEditUser(false)
      setOpenModalUsuarios(true)
    } catch (error) {
      console.error(error)
    }
  }

  const goToPermisos = () => {
    try {
      if (usuario.Id <= 0) {
        msgNotificacion('Seleccione el usuario', 'warning')
        return
      }

      setUsuario({
        ...usuario, Nombre: dataUsuarios.filter(item => item.IdUsuario === usuario.Id)[0].Nombre
      })

      setOpenModalPermisos(true)
    } catch (error) {
      console.error(error)      
    }
  }
  
  const getRoles = async () => {
    try {
      SeguridadService.getRoles()
      .then((response) => {
          if (!response) {
            msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')            
            return
          }

          if (response.Codigo === 1) {
            setDataRoles(response.Data)
          } else {
            setDataRoles([])
            msgNotificacion(response.Mensaje, 'info')
          }
      })
      .catch((error) => {        
        msgNotificacion(error, 'error')
      })
    } catch (error) {
      console.error(error)
    }
  }
 
  let didInit = false

  useEffect(() => {
    document.title = `Listado de Usuarios - ${NAME_PROJECT}`

    try {
      dispatch(showProgress(true))
      setTimeout(() => {
        
        if (!didInit) {          
          didInit = true

          const data = {
            codigoRol: -1
          }

          getUsuarios(data)
          getRoles()
        }
  
        dispatch(showProgress(false))
      }, 1000) 
    } catch (error) {
      console.error(error)
    }
  }, [])

  useEffect(() => {
    try {      
      if (!didInit) {
        if (!openModalUsuarios) {
          if (!noChanges) {
            const data = {
              IdRol: -1
            }
            
            setDataUsuarios([])
            getUsuarios(data)
            setNoChanges(true)
          }
        }
      }
    } catch (error) {
      console.error(error)
    }    
  }, [openModalUsuarios, didInit])

  return (
    <div className='App-content'>
      <Heading className='mt-0 py-0 w-100 heading justify-content-center'>
        <div className='heading-text'>
          <i className='bx bxs-user-circle mx-1'></i>
          <span>Administración de usuarios</span>
        </div>       
      </Heading>

      <div className='row w-100 mb-4'>
        <ModalPermisos
          setOpenModal={setOpenModalPermisos}
          openModal={openModalPermisos}
          usuario={usuario}
        />

        <ModalUsuarios
          setOpenModal={setOpenModalUsuarios}
          openModal={openModalUsuarios}
          setNoChanges={setNoChanges}
          dataUsuario={dataUsuarioSelected}
          dataRoles={dataRoles}
          isEdit={editUser}          
        />

        <Grid container spacing={1}>
          <Grid item xs={12} md={12} className='pb-2 heading-buttons'>
            <Button
              variant='contained'
              color='info'
              className='text-transform-none float-right me-2'
              startIcon={<PersonAddAltIcon />}
              size='small'
              onClick={() => addUsers()}
            >
              Agregar
            </Button>
            <Button
              variant='contained'
              color='secondary'
              className='text-transform-none float-right me-2'
              startIcon={<ManageAccountsIcon />}
              size='small'
              onClick={() => goToPermisos()}
            >
              Permisos
            </Button>
          </Grid>

          <Grid item xs={12} md={12}>
            <Item className='MuiPaper-root-dataGrid'>
              <DataGrid                
                rows={dataUsuarios}
                columns={columns}
                getRowId={(row) => row?.IdUsuario}
                pageSize={PAGE_SIZE}
                pageSizeOptions={[5, 10, 25, 50, 100]}
                loading={loading}                                
                localeText={Formatter.localizedTextsMapColumns}                    
                onRowSelectionModelChange={(selection) => {                  
                  if (selection.length > 1) {
                    const selectionSet = new Set(selectionModel)
                    const result = selection.filter((s) => !selectionSet.has(s))                    

                    setSelectionModel(result)
                    setUsuario({ ...usuario, Id: result[0] })
                  } else {
                    setSelectionModel(selection)
                    setUsuario({ ...usuario, Id: selection[0] })
                  }
                }}
                // Ocultar la casilla de check all.
                sx={{
                  "& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer": {
                    display: "none"
                  }
                }}
                getRowClassName={(params) =>
                  params.row.IsBaja === true ? 'bg-default' : ''
                }
                rowSelectionModel={selectionModel}
                showCellVerticalBorder
                showColumnVerticalBorder
                checkboxSelection
                density='compact'
                slots={{
                  noRowsOverlay: CustomNoRowsOlverlay
                }}
              />
            </Item>
          </Grid>
        </Grid>
      </div>
    </div>
  )
}